import PropTypes from 'prop-types';

import { YoutubeVideo } from '@spotahome/ui-library';

import './SliderTrackVideo.scss';

const SliderTrackVideo = ({ item }) => (
  <div className="slider-video">
    <YoutubeVideo {...item} />
  </div>
);

SliderTrackVideo.propTypes = {
  item: PropTypes.shape(YoutubeVideo.propTypes).isRequired
};

export default SliderTrackVideo;
